import { AdvancedFilterInputSchema } from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import { BatchSuggestionWithGroupsSchema } from "@redotech/redo-fulfillment-operations-common/batch-suggestion";
import * as z from "zod";

export const getBatchSuggestionsByKeys = {
  name: "getBatchSuggestionsByKeys" as const,
  input: z.object({
    batchKeys: z.array(z.string()),
    advancedFiltersInput: AdvancedFilterInputSchema,
  }),
  output: z.object({ suggestions: z.array(BatchSuggestionWithGroupsSchema) }),
};
